import { Col, Row } from "./layout.jsx";
import {
  Request,
  RequestFooter,
  RequestHeader,
  RequestHeaderItem,
  RequestHeaderLine,
  RequestSection,
} from "./requests.jsx";

import { format } from "../../common/date.js";
import { formatCurrency } from "../../common/currency.js";
import { styled } from "../util/style.js";

export default styled(function TrainingVoucherItem({
  className,
  ...voucherProps
}) {
  const { voucherCode, amount, expirationDate, reference, usedAt } =
    voucherProps;

  // Si créé il y a moins de X minutes
  const isRecenltyUsed = (new Date() - new Date(usedAt)) / 1000 / 60 < 30; // minutes
  // Si expire dans moins d'un mois (on suppose qu'on ne renvoie pas les expirations passées)
  const isOld =
    (new Date(expirationDate) - new Date()) / 1000 / 60 / 60 / 24 < 30; // jours

  return (
    <Request className={className} highlight={isRecenltyUsed}>
      <RequestHeader>
        <RequestHeaderLine>
          <RequestHeaderItem strong grey={isOld}>
            {voucherCode || "-"}
          </RequestHeaderItem>
          <RequestHeaderItem strong primary={isRecenltyUsed}>
            {formatCurrency(amount)}
          </RequestHeaderItem>
        </RequestHeaderLine>
        <RequestHeaderLine>
          <RequestHeaderItem small>Créé le {format(usedAt)}</RequestHeaderItem>
        </RequestHeaderLine>
      </RequestHeader>

      {Boolean(reference) && (
        <RequestSection>
          <div>
            Référence{" : "}
            {reference}
          </div>
        </RequestSection>
      )}
    </Request>
  );
})``;
